import { render, staticRenderFns } from "./IconLockOpen.vue?vue&type=template&id=ab4e2fe2&scoped=true&"
import script from "./IconLockOpen.vue?vue&type=script&lang=js&"
export * from "./IconLockOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4e2fe2",
  null
  
)

export default component.exports